import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import config from '../../variables/config'
import { bindActionCreators } from 'redux'
import './party.scss'
import moment from 'moment'
import Payment from '../views/payment'
import Alert from '../views/alert'
import { connect } from 'react-redux'
import { isBlank } from '../helpers/validation'
import { userSearchFilter } from '../helpers/userSearch'
import { fetchBookingDates } from '../../modules/bookings'
import {
  updateBooking,
  changeFinished as changeFinished2,
  editFinished,
  deleteBooking
} from '../../modules/bookedit'
import IosCloseCircleOutline from 'react-ionicons/lib/IosCloseCircleOutline'
import IosArrowDown from 'react-ionicons/lib/IosArrowDown'
import IosArrowRoundBack from 'react-ionicons/lib/IosArrowRoundBack'
import DatePicker from 'react-date-picker'
import { sendRequest } from '../../modules/admin'
import {
  changeFinished,
  fetchNone,
  newUserRequired,
  newUserNotRequired,
  updateUser,
  redirectDone
} from '../../modules/users'

import extraItems from '../helpers/extraItems'
import types from '../helpers/partyTypes'
import { storedMoneyToPounds } from '../helpers/storedMoney'
// import themeTypes from '../helpers/themeTypes';

const bookPartyText = 'Book a party'
const bookParty2Text = 'Change the party'
const selectTypeText = 'Party Type'
const selectText = 'Select'
const changeText = 'Change'
const deselectText = 'Deselect'
const packagesText = 'Packages Includes'
const partyTimeText = 'Party Time'
const partyDetailsText = 'Party Details'
const partyForText = 'Who is this party for'
const howOldText = 'How old'
const partyReasonText = 'The reason for the party'
const genderText = "Party Child's Gender?"
const dateOfBirth = 'Date of Birth (birthday child)'
const menuText = 'Menu Options'
const wheelchairText = 'Do you require wheelchair access?'
const extraAdultsText = 'Happy to pay for extra adults?'
const extraChildrenText = 'Happy to pay for extra children?'
const themeTitleText = 'Theme items'
const childrenNumText = 'Number of children'
const siblingNumText = 'Number of siblings'
const firstNameText = 'First name'
const lastNameText = 'Last name'
const emailText = 'Email'
const phoneText = 'Phone number'
const restToPayText = 'Rest of payment'
const finalDue = 'Final Payment'
const finalDueWhen = 'When Paid'
const finalDueMethod = 'Final Pay Method'
const finalDueCashier = 'Processed Team'
const paidAmountText = 'Paid Initially'

const subtotalText = 'Subtotal'
const extraItemsText = 'Extra items'
const mascotItemsText = 'Mascot items'

const amountText = 'Total Amount'
const initialText = 'Before Price Change'
const offPriceText = 'Off Peak price'
const peakPriceText = 'Peak price'
const addItemText = 'Add custom item'
const customNameText = 'Name'
const customPriceText = 'Price'
const cancelText = 'Cancel'
const submitText = 'Submit'
const priceText = 'Price'
const totalText = 'Total'
const payText = 'Pay'
const depositText = 'Deposit'
const discountedTotalText = 'Amount with discount'
const discountCodeText = 'Discount code'
const applyText = 'Apply'
const invalidCodeText = 'Invalid Discount Code'
const pleaseSelectUText = 'Please select a user'
const searchText = 'Search by name or surname or email'
const addUserText = 'Add new user'
const pleaseSelectText = 'Please select a user'
const pleaseSelectTText = 'Please select the party type'
const pleaseSelectNText = 'Please select the amount of quests'
const errorMessage1Text = 'Something went wrong, please try again later'
const tryAgainText = 'Please try again later'
const userText = 'User'
const discountCustomText = 'Amount to discount'
const noteText = 'Note'
const extraGuests = 'Extra guests (need Food)'
const depositAmountText = 'Deposit'
const depositAmountText2 = 'How much paid already'
const hideItem = 'Show All Extras'
const showItem = 'Hide Extras'

const deleteText = 'Delete'
const warningText = 'Warning'
const warningMessageText =
  'This action is irreversible, please confirm your intent.'
const confirmText = 'Confirm'
const updateTimeText = 'To be reschedule'

const menuItems1 = ['Lunch Boxes', 'Ham Rolls', 'Jam Rolls', 'Cheese Rolls']

const menuItems2 = ['Hot Dog', 'Pizza', 'Cheese Panini', 'Fish Fingers']

// const timeSlots = [
//   "9:00am - 11:00am",
//   "10:00am - 12:00pm",
//   "11:00am - 13:00pm",
//   "12:00pm - 14:00pm",
//   "13:00pm - 15:00pm",
//   "14:00pm - 16:00pm",
//   "15:00pm - 17:00pm"
// ]

const reasons = ['Birthday', 'Baby shower', 'Event', 'Other']

var currentYear = new Date().getYear() + 1900

const days = [...new Array(31)].map((ignore, index) => {
  return index + 1
})
const years = [...new Array(currentYear - 1970)].map((ignore, index) => {
  return currentYear - index
})
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

var hours = []
for (var i = 0; i < 24; i++) {
  if (i < 10) {
    hours.push('0' + i)
  } else {
    hours.push('' + i)
  }
}

var minutes = []
for (var j = 0; j < 60; j++) {
  if (j < 10) {
    minutes.push('0' + j)
  } else {
    minutes.push('' + j)
  }
}

const emptyAlert = {
  showAlert: false,
  message: '',
  type: '',
  callback: () => {}
}

var originalItems = []

var oneTimeSwitch = true

class Party extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      paymentDone: false,
      shouldClose: false,
      selectedType: null,
      partyDate: new Date(),
      selectedTheme: null,
      openedTypes: [],
      openedThemes: [],
      openedItems: [],
      childrenNum: 0,
      youngSiblings: 0,
      additionalDetails: {
        partyReason: 'Birthday',
        whoIsPartyFor: '',
        partyChildGender: 'Female',
        howOldWillTheyBe: 0,
        partyChildDOB: {
          day: 1,
          month: 'Jan',
          year: 2010
        },
        menuOptions: '',
        requireWheelchairAccess: false,
        payForExtraAdults: true,
        payForExtraChildren: true
      },
      themeAmounts: [],
      itemsAmounts: [],
      mascotsAmounts: [],
      openAddItem: false,
      newItem: {
        name: '',
        description: [],
        price: 0
      },
      discount: {
        discountInput: '',
        discountApplied: false,
        discountInstance: {}
      },
      paymentMethod: {},
      alert: _.clone(emptyAlert),
      selectedUser: {
        selected: false,
        user: {}
      },
      search: '',
      selectedTime: undefined,
      privatePrice: 0,
      privateSelected: false,
      customDiscount: 0,
      note: '',
      customHours: '00',
      customMinutes: '00',
      extraGuests: 0,
      depositAmount: 0,
      totalDeposit: 0,
      amountPaid: 0,
      isDeposit: false,
      themeItems: [],
      extraItems: [],
      mascotItems: [],
      openDelete: false,
      finalDue: 0,
      finalDueMethod: '',
      finalDueWhen: '',
      finalDueCashier: '',
      showAll: false,
      items: []
    }
  }

  componentDidUpdate = () => {
    var temp = this.getSlots(this.state.partyDate)
    if (
      this.props.partyEditOn &&
      temp.includes(this.props.partyObj.partyTime) &&
      this.state.selectedTime === 'Custom' &&
      oneTimeSwitch
    ) {
      oneTimeSwitch = false
      this.setState({
        selectedTime: this.props.partyObj.partyTime
      })
    }
  }

  componentDidMount = () => {
    oneTimeSwitch = true
    this.fetchData()
    this.props.sendRequest(fetchBookingDates)
  }

  partyEditSetup = () => {
    if (this.props.partyEditOn) {
      // this.cleanItems();
      var themeAmounts = this.getThemeAmounts()
      var itemsAmounts = this.getItemsAmounts()
      var mascotsAmounts = this.getMascotsAmounts()

      var additionalDetails = _.cloneDeep(this.props.partyObj.additionalDetails)

      var discountDetails = _.cloneDeep(this.props.partyObj.discountDetails)
      var additionalDetails2 = this.getAditionalDetails(additionalDetails)

      var typeLength = this.props.partyObj.partyType.length
      var childrenNum = this.props.partyObj.attendeeDetails.quantity
        ? this.props.partyObj.attendeeDetails.quantity
        : 0
      var youngSiblings = this.props.partyObj.attendeeDetails.youngSiblings
        ? this.props.partyObj.attendeeDetails.youngSiblings
        : 0

      // childrenNum -= youngSiblings;

      const selectedType = _.findIndex(
        _.clone(types),
        t => t.name.substring(0, typeLength) === this.props.partyObj.partyType
      )
      const privateSelected = selectedType >= types.length - 2
      const deposit = this.props.partyObj.attendeeDetails.deposit
      const totalPricePence = this.props.partyObj.attendeeDetails.totalPrice
      const isDiscountApplied =
        discountDetails.discountCode && discountDetails.discountCode !== ''

      var isCustom = false
      var customHours = '00'
      var customMinutes = '00'

      // if (!timeSlots.includes(this.props.partyObj.partyTime)) {
      isCustom = true
      var times = this.props.partyObj.partyTime.split(' - ')[0].split(':')
      customMinutes = times[1].substring(0, 2)

      var hours = Number(times[0])
      if (hours < 10) {
        customHours = '0' + hours
      } else {
        customHours = String(hours)
      }
      // }

      this.setState(
        {
          finalDue: this.props.partyObj.finalDue,
          finalDueMethod: this.props.partyObj.finalDueMethod,
          finalDueWhen: this.props.partyObj.finalDueWhen,
          finalDueCashier: this.props.partyObj.finalDueCashier,
          additionalDetails: additionalDetails,
          customHours: customHours,
          customMinutes: customMinutes,
          themeAmounts: themeAmounts,
          itemsAmounts: itemsAmounts,
          mascotsAmounts: mascotsAmounts,
          note: this.props.partyObj.note,
          selectedType: selectedType,
          childrenNum: childrenNum,
          extraGuests: this.props.partyObj.attendeeDetails.extraGuests
            ? this.props.partyObj.attendeeDetails.extraGuests
            : 0,
          youngSiblings: youngSiblings,
          privateSelected: privateSelected,
          depositAmount:
            deposit && deposit > 0
              ? storedMoneyToPounds(deposit, totalPricePence)
              : 0,
          totalPrice: totalPricePence / 100,
          totalDeposit:
            this.props.partyEditOn &&
            this.props.partyObj.attendeeDetails.totalDeposit != undefined
              ? storedMoneyToPounds(
                  this.props.partyObj.attendeeDetails.totalDeposit,
                  totalPricePence
                )
              : this.props.partyObj.discountDetails.discountedTotal
              ? storedMoneyToPounds(
                  this.props.partyObj.discountDetails.discountedTotal,
                  totalPricePence
                )
              : storedMoneyToPounds(totalPricePence, totalPricePence),
          amountPaid:
            this.props.partyObj.attendeeDetails.totalDeposit != undefined
              ? storedMoneyToPounds(
                  this.props.partyObj.attendeeDetails.totalDeposit,
                  totalPricePence
                )
              : this.props.partyObj.discountDetails.discountedTotal
              ? storedMoneyToPounds(
                  this.props.partyObj.discountDetails.discountedTotal,
                  totalPricePence
                )
              : storedMoneyToPounds(totalPricePence, totalPricePence),
          partyDate: new Date(this.props.partyObj.partyDate),
          selectedTime: isCustom ? 'Custom' : this.props.partyObj.partyTime,
          additionalDetails: additionalDetails2,
          customDiscount: this.props.partyObj.attendeeDetails.customDiscount
            ? this.props.partyObj.attendeeDetails.customDiscount
            : 0,
          discount: {
            discountedAmount: discountDetails.discountedTotal,
            discountInput: isDiscountApplied
              ? discountDetails.discountCode
              : '',
            discountApplied: isDiscountApplied,
            discountInstance: {
              percentage: discountDetails.discountInstance
                ? discountDetails.discountInstance.percentage
                : 0
            }
          }
        },
        () => this.init()
      )
    } else {
      this.init()
    }
  }

  fetchData = async () => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token
    try {
      var themeItems = (await axios.get(
        config.serverURL + '/ThemeItems' + '?access_token=' + token
      )).data
      var extraItems = (await axios.get(
        config.serverURL + '/ExtraItems' + '?access_token=' + token
      )).data
      var mascotItems = (await axios.get(
        config.serverURL + '/MascotItems' + '?access_token=' + token
      )).data

      themeItems.forEach(item => {
        item.description = [item.description, item.secondaryText]
      })

      originalItems = _.clone(extraItems)
      this.setState(
        {
          extraItems: extraItems,
          themeItems: themeItems,
          mascotItems: mascotItems
        },
        () => {
          this.partyEditSetup()
        }
      )
    } catch (error) {
      console.log('party - fetchData:', error.message)
    }
  }

  toggleItems = () => {
    this.setState({
      showAll: !this.state.showAll
    })
  }

  getItemsAmounts = () => {
    var itemsAmounts = []

    var missing = []
    for (var i = 0; i < this.props.partyObj.extraItems.length; i++) {
      var found = false
      for (var j = 0; j < this.state.extraItems.length; j++) {
        if (
          this.props.partyObj.extraItems[i].name !==
            this.state.extraItems[j].name &&
          j + 1 === this.state.extraItems.length &&
          !found
        ) {
          missing.push(this.props.partyObj.extraItems[i])
        }

        if (
          this.props.partyObj.extraItems[i].name ===
          this.state.extraItems[j].name
        ) {
          found = true
        }
      }
    }
    missing.forEach(miss => {
      miss.description = []
      // if (miss.price < 100) {
      //   miss.price = miss.price * 100;
      // }
      this.state.extraItems.push(miss)
    })

    this.state.extraItems.forEach(item => {
      for (var i = 0; i < this.props.partyObj.extraItems.length; i++) {
        if (item.name === this.props.partyObj.extraItems[i].name) {
          itemsAmounts.push(this.props.partyObj.extraItems[i].quantity)
          return
        }
      }

      itemsAmounts.push(0)
    })

    return itemsAmounts
  }

  getThemeAmounts = () => {
    var themeAmounts = []
    var missing = []
    for (var i = 0; i < this.props.partyObj.themeItems.length; i++) {
      var found = false
      for (var j = 0; j < this.state.themeItems.length; j++) {
        if (
          this.props.partyObj.themeItems[i].name !==
            this.state.themeItems[j].name &&
          j + 1 === this.state.themeItems.length &&
          !found
        ) {
          missing.push(this.props.partyObj.themeItems[i])
        }

        if (
          this.props.partyObj.themeItems[i].name ===
          this.state.themeItems[j].name
        ) {
          found = true
        }
      }
    }
    missing.forEach(miss => {
      miss.description = []
      this.state.themeItems.push(miss)
    })

    this.state.themeItems.forEach(item => {
      for (var i = 0; i < this.props.partyObj.themeItems.length; i++) {
        if (item.name === this.props.partyObj.themeItems[i].name) {
          themeAmounts.push(this.props.partyObj.themeItems[i].quantity)
          return
        }
      }

      themeAmounts.push(0)
    })

    return themeAmounts
  }

  getMascotsAmounts = () => {
    var mascotsAmounts = []

    var missing = []

    if (
      this.props.partyObj.mascotItems &&
      this.props.partyObj.mascotItems.length > 0
    ) {
      for (var i = 0; i < this.props.partyObj.mascotItems.length; i++) {
        var found = false
        for (var j = 0; j < this.state.mascotItems.length; j++) {
          if (
            this.props.partyObj.mascotItems[i].name !==
              this.state.mascotItems[j].name &&
            j + 1 === this.state.mascotItems.length &&
            !found
          ) {
            missing.push(this.props.partyObj.mascotItems[i])
          }

          if (
            this.props.partyObj.mascotItems[i].name ===
            this.state.mascotItems[j].name
          ) {
            found = true
          }
        }
      }
      missing.forEach(miss => {
        miss.description = []
        // if (miss.price < 100) {
        //   miss.price = miss.price * 100;
        // }
        this.state.mascotItems.push(miss)
      })
    }

    this.state.mascotItems.forEach(item => {
      if (
        this.props.partyObj.mascotItems &&
        this.props.partyObj.mascotItems.length > 0
      ) {
        for (var i = 0; i < this.props.partyObj.mascotItems.length; i++) {
          if (item.name === this.props.partyObj.mascotItems[i].name) {
            mascotsAmounts.push(this.props.partyObj.mascotItems[i].quantity)
            return
          }
        }
      }

      mascotsAmounts.push(0)
    })

    return mascotsAmounts
  }

  getAditionalDetails = additionalDetails => {
    var additionalDetails2 = {
      partyReason: additionalDetails.partyReason
        ? additionalDetails.partyReason
        : 'Birthday',
      whoIsPartyFor: additionalDetails.whoIsPartyFor
        ? additionalDetails.whoIsPartyFor
        : '',
      partyChildGender: additionalDetails.partyChildGender
        ? additionalDetails.partyChildGender
        : 'Female',
      howOldWillTheyBe: additionalDetails.howOldWillTheyBe
        ? additionalDetails.howOldWillTheyBe
        : 0,
      partyChildDOB: {
        day:
          additionalDetails.partyChildDOB && additionalDetails.partyChildDOB.day
            ? additionalDetails.partyChildDOB.day
            : 1,
        month:
          additionalDetails.partyChildDOB &&
          additionalDetails.partyChildDOB.month
            ? additionalDetails.partyChildDOB.month.substring(0, 3)
            : 'Jan',
        year:
          additionalDetails.partyChildDOB &&
          additionalDetails.partyChildDOB.year
            ? additionalDetails.partyChildDOB.year
            : 2010
      },
      menuOptions: additionalDetails.menuOptions
        ? additionalDetails.menuOptions
        : this.state.selectedType === 0 ||
          this.state.selectedType === 3 ||
          this.state.selectedType === 4 ||
          this.state.selectedType === 7
        ? 'Ham Rolls'
        : 'Hot Dogs',
      requireWheelchairAccess: additionalDetails.requireWheelchairAccess
        ? additionalDetails.requireWheelchairAccess
        : false,
      payForExtraAdults: additionalDetails.payForExtraAdults
        ? additionalDetails.payForExtraAdults
        : true,
      payForExtraChildren: additionalDetails.payForExtraChildren
        ? additionalDetails.payForExtraChildren
        : true
    }

    return additionalDetails2
  }

  getCustomTime = () => {
    var hour = Number(this.state.customHours)
    var minute = this.state.customMinutes
    var fullTime = ''
    var endHour
    if (hour + 2 < 24) {
      endHour = hour + 2
    } else {
      endHour = hour + 2 - 24
    }

    if (hour < 12) {
      fullTime = hour + ':' + minute + 'am - '
    } else {
      fullTime = hour + ':' + minute + 'pm - '
    }

    if (endHour < 12) {
      fullTime = fullTime + endHour + ':' + minute + 'am'
    } else {
      fullTime = fullTime + endHour + ':' + minute + 'pm'
    }

    return fullTime
  }

  init = applyDiscount => {
    if (applyDiscount) {
      this.applyDiscount()
    }
    if (
      this.props.userForBooking.required &&
      this.props.userForBooking.user.id
    ) {
      this.setState({
        selectedUser: {
          selected: true,
          user: this.props.userForBooking.user
        }
      })
      this.props.newUserNotRequired()
    }
    this.props.sendRequest(fetchNone)
    this.initOpened(
      types,
      this.state.themeItems,
      this.state.extraItems,
      this.state.mascotItems
    )
  }

  initOpened = (types, themes, items) => {
    this.setState({
      themeAmounts: [...new Array(themes.length)].map((ignore, i) =>
        this.state.themeAmounts[i] ? this.state.themeAmounts[i] : 0
      ),
      itemsAmounts: [...new Array(items.length)].map((ignore, i) =>
        this.state.itemsAmounts[i] ? this.state.itemsAmounts[i] : 0
      ),
      mascotsAmounts: [...new Array(items.length)].map((ignore, i) =>
        this.state.mascotsAmounts[i] ? this.state.mascotsAmounts[i] : 0
      ),
      openedTypes: [...new Array(types.length)].map((ignore, i) =>
        this.state.openedTypes[i] ? this.state.openedTypes[i] : false
      ),
      openedThemes: [...new Array(themes.length)].map((ignore, i) =>
        this.state.openedThemes[i] ? this.state.openedThemes[i] : false
      ),
      openedItems: [...new Array(items.length)].map((ignore, i) =>
        this.state.openedItems[i] ? this.state.openedItems[i] : false
      )
    })
  }

  // cleanItems = () => {
  //   for (var i = 0; i <= extraItems.length; i++) {
  //     extraItems.pop();
  //   }
  //
  //   originalItems.forEach(item => {
  //     extraItems.push(item)
  //   })
  // }

  animateClose = () => {
    if (this.props.partyEditOn) {
      this.props.redirectDone()
      this.props.editFinished()
    }
    // this.setState({
    //   shouldClose: true
    // }, () => {
    //   setTimeout(() => {
    this.props.closeWindow()
    //   }, 500)
    // })
  }

  toogleOpenedType = i => {
    var openedTypes = this.state.openedTypes
    openedTypes[i] = !this.state.openedTypes[i]

    this.setState({
      openedTypes: openedTypes
    })
  }

  toogleOpenedItem = i => {
    var openedItems = this.state.openedItems
    openedItems[i] = !this.state.openedItems[i]

    this.setState({
      openedItems: openedItems
    })
  }

  toogleOpenedTheme = i => {
    var openedThemes = this.state.openedThemes
    openedThemes[i] = !this.state.openedThemes[i]

    this.setState({
      openedThemes: openedThemes
    })
  }

  selectType = i => {
    var privateSelected = false
    var childrenNum = this.state.childrenNum

    if (this.state.selectedType !== i && i >= types.length - 2) {
      privateSelected = true
      //console.log(types[this.state.selectedType] === 'Platinum Party - Zebra', types[this.state.selectedType] === 'Platinum Party - Zebra' ? 20 : 12)
      childrenNum = types[i].name === 'Platinum Party - Zebra' ? 25 : 20
    }
    this.setState({
      childrenNum: childrenNum,
      privateSelected: privateSelected,
      selectedType: this.state.selectedType === i ? null : i
    })
  }

  selectTheme = i => {
    this.setState({
      selectedTheme: this.state.selectedTheme === i ? null : i
    })
  }

  handleDateChange = date => {
    this.setState({
      partyDate: date
    })
  }

  timeChange = time => {
    this.setState({
      selectedTime: time.target.value
    })
  }

  applyDiscount = async () => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token

    if (isBlank(this.state.discount.discountInput))
      return this.showAlert(invalidCodeText, 'warning')
    try {
      const response = await axios.post(
        config.serverURL + '/isDiscountCodeValid',
        {
          code: this.state.discount.discountInput.trim()
        }
      )

      if (response.data.isValid) {
        this.setState({
          discount: {
            ...this.state.discount,
            discountApplied: true,
            discountInstance: response.data.instance
          }
        })
      } else {
        this.showAlert(invalidCodeText, 'warning')
      }
    } catch (error) {
      this.showAlert(invalidCodeText, 'warning')
      console.log('payment - applyDiscount:', error.message)
    }
  }

  animateCloseOpen = redirect => {
    if (redirect === 'register') this.props.newUserRequired('party')

    // this.setState({
    //   shouldClose: true
    // }, () => {
    //   setTimeout(() => {
    this.props.closeOpenWindow(redirect)
    //   }, 500)
    // })
  }

  selectUser = user => {
    this.setState({
      selectedUser: {
        user: user,
        selected: true
      }
    })
  }

  unselectUser = () => {
    this.setState({
      selectedUser: {
        user: {},
        selected: false
      }
    })
  }

  search = () => {
    var items = _.clone(this.props.users)

    var search = this.state.search.toLowerCase()
    var filteredItems = items.filter(item => {
      if (item.firstName.substring(0, search.length).toLowerCase() === search)
        return true
      else if (
        item.lastName.substring(0, search.length).toLowerCase() === search
      )
        return true
      else if (item.email.substring(0, search.length).toLowerCase() === search)
        return true
      else return false
    })

    return filteredItems
  }

  openPayment = isDeposit => {
    var message = ''

    if (!this.state.selectedUser.selected) message = pleaseSelectText
    else if (this.state.selectedType === null) message = pleaseSelectTText
    else if (this.state.childrenNum === 0 || this.state.childrenNum === '')
      message = pleaseSelectNText

    if (message !== '') {
      var alert = {
        showAlert: true,
        message: message,
        type: 'warning',
        callback: () => {
          this.setState({ alert: _.clone(emptyAlert) })
        }
      }
      this.setState({ alert })
    } else {
      this.setState({
        isDeposit: isDeposit,
        showPayment: true
      })
    }
  }

  closePayment = () => {
    this.setState({
      showPayment: false
    })
  }

  getSearchItems = async () => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token
    const filter = userSearchFilter(this.state.search)
    const checkWKUser = await axios.get(
      config.serverURL +
        '/WKUsers?filter=' +
        filter +
        '&access_token=' +
        token
    )
    const checkOnsiteUser = await axios.get(
      config.serverURL +
        '/OnsiteUsers?filter=' +
        filter +
        '&access_token=' +
        token
    )

    var items = checkWKUser.data.concat(checkOnsiteUser.data)

    if (this.state.search === '') {
      this.setState({ items: this.props.recentUsers })
    } else {
      this.setState({ items: items })
    }

    if (!Array.isArray(this.state.items)) {
      this.setState({ items: [] })
    }

    // return (
    //   <div className="searchWrapper searchBorder">
    //     {items.map((item, index) => {
    //       return (
    //         <div
    //           className={
    //             'searchRow smallText' +
    //             (index + 1 === items.length ? ' noBorder' : '')
    //           }
    //           key={index}
    //           onClick={() => this.selectUser(item)}>
    //           <div>{item.firstName + ' ' + item.lastName}{' '}-{' '}
    //           {item.adminId ? 'Site' : 'Online'}</div>
    //           <div>{item.email}</div>
    //         </div>
    //       )
    //     })}
    //   </div>
    // )
  }

  formatDate = date => {
    const monthsArray = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
    const day = date.getDate()
    const month = monthsArray[date.getMonth()]
    const year = date.getFullYear()

    var suffix

    switch (day) {
      case 1:
      case 21:
      case 31:
        suffix = 'st'
        break
      case 2:
      case 22:
        suffix = 'nd'
        break
      case 3:
      case 23:
        suffix = 'rd'
        break
      default:
        suffix = 'th'
    }

    return day + suffix + ' ' + month + ', ' + year
  }

  submit = async paymentMethod => {
    var errorMessage = errorMessage1Text
    var message = ''

    if (!this.state.selectedUser.selected) message = pleaseSelectText
    else if (this.state.selectedType === null) message = pleaseSelectTText
    else if (this.state.childrenNum === 0 || this.state.childrenNum === '')
      message = pleaseSelectNText

    if (message !== '') {
      this.showAlert(message, 'warning')
      if (paymentMethod) {
        this.setState({
          paymentDone: true,
          showPayment: false,
          paymentMethod: paymentMethod
        })
      }
      return
    }

    if (paymentMethod) {
      this.setState({
        paymentDone: true
      })
    }

    if (!paymentMethod && this.state.paymentMethod.id)
      paymentMethod = this.state.paymentMethod

    try {
      var type = types[this.state.selectedType]
      var dayOfWeek = new Date(this.state.partyDate).getDay()
      if (isNaN(dayOfWeek)) return 'Date error'

      var additionalDetails = _.clone(this.state.additionalDetails)
      additionalDetails.partyChildDOB.month = this.getFullMonth(
        additionalDetails.partyChildDOB.month
      )

      var partyTime
      if (this.state.selectedTime === 'Custom') {
        partyTime = this.getCustomTime()
      } else {
        partyTime = this.state.selectedTime
          ? this.state.selectedTime
          : this.getSlots(this.state.partyDate)[0]
      }

      var deposit = 0
      if (paymentMethod) {
        if (!this.state.isDeposit) {
          deposit = isNaN(this.getTotalPrice())
            ? 0
            : isNaN(this.getDiscountPrice()) ||
              this.getDiscountPrice() === 'N/A'
            ? this.getTotalPrice()
            : this.getDiscountPrice()
        } else {
          deposit =
            Number(this.state.depositAmount || this.state.totalDeposit) * 100
        }
      }

      var fullPrice = this.state.discount.isDiscountApplied
        ? this.getDiscountPrice() / 100
        : this.getTotalPrice() / 100

      var price =
        dayOfWeek === 0 || dayOfWeek === 6 ? type.peakPrice : type.offPrice

      this.props.bookingDates.forEach(dateObj => {
        if (
          this.isBetween(
            dateObj.startDate,
            dateObj.endDate,
            this.state.partyDate
          )
        ) {
          var dayOfWeek = moment(this.state.partyDate).day()
          var date2 = _.clone(dateObj['' + dayOfWeek])
          price = date2.peak ? type.peakPrice : type.offPrice
        }
      })

      additionalDetails.menuOptions = additionalDetails.menuOptions
        ? additionalDetails.menuOptions
        : this.state.selectedType === 0 ||
          this.state.selectedType === 3 ||
          this.state.selectedType === 4 ||
          this.state.selectedType === 7
        ? 'Ham Rolls'
        : 'Hot Dogs'

      var partyDate = new Date(this.state.partyDate)
      partyDate.setHours(10)

      var partyBooking = {
        orderDate: new Date(),
        partyType: type.name,
        partyDate: partyDate,
        partyTime: partyTime,
        discountDetails: {
          discountCode: this.state.discount.discountApplied
            ? this.state.discount.discountInput
            : '',
          discountInstance: {
            percentage: this.state.discount.discountInstance.percentage
          },
          discountedTotal: this.state.discount.discountApplied
            ? this.getDiscountPrice()
            : 0
        },
        attendeeDetails: {
          extraGuests: this.state.extraGuests,
          deposit: deposit,
          totalDeposit: this.state.isDeposit
            ? Number(this.state.totalDeposit) * 100
            : deposit || Number(this.state.totalDeposit) * 100,
          amountPaid: paymentMethod
            ? isNaN(this.getTotalPrice())
              ? 0
              : isNaN(this.getDiscountPrice()) ||
                this.getDiscountPrice() === 'N/A'
              ? this.getTotalPrice()
              : this.getDiscountPrice()
            : 0,
          youngSiblings: this.state.youngSiblings,
          singleTicketPrice: price,
          quantity: Number(this.state.childrenNum),
          totalPrice: isNaN(this.getTotalPrice()) ? 0 : this.getTotalPrice(),
          customDiscount: Number(this.state.customDiscount)
        },
        additionalDetails: additionalDetails,
        themeItems: this.state.themeAmounts.map((amount, i) => {
          return {
            name: this.state.themeItems[i].name,
            quantity: amount === '' ? 0 : amount,
            price: this.state.themeItems[i].price
          }
        }),
        extraItems: this.state.itemsAmounts.map((amount, i) => {
          return {
            name: this.state.extraItems[i].name,
            quantity: amount === '' ? 0 : amount,
            price: this.state.extraItems[i].price
          }
        }),
        note: this.state.note,
        reference: this.generateReferenceNumber('WKPB'),
        paymentMethod: paymentMethod ? paymentMethod : {},
        onsiteUserId: this.state.selectedUser.user.id
      }

      const emailDetails = {
        deposit: '£' + Number(this.state.totalDeposit),
        email: this.state.selectedUser.user.email,
        bookingRefNo: partyBooking.reference + 'PT',
        paymentDate: this.formatDate(new Date()),
        name:
          this.state.selectedUser.user.firstName +
          ' ' +
          this.state.selectedUser.user.lastName,
        partyDetails: partyBooking,
        themeItems: partyBooking.themeItems,
        extraItems: partyBooking.extraItems,
        partyPrice: '£' + fullPrice,
        partyDate: this.formatDate(new Date(partyBooking.partyDate))
      }

      const emailToAdmin = {
        deposit: '£' + Number(this.state.totalDeposit),
        email: 'admin@wackykingdom.com',
        bookingRefNo: 'Portal Booking ' + partyBooking.reference,
        paymentDate: this.formatDate(new Date()),
        name:
          this.state.selectedUser.user.firstName +
          ' ' +
          this.state.selectedUser.user.lastName,
        partyDetails: partyBooking,
        themeItems: partyBooking.themeItems,
        extraItems: partyBooking.extraItems,
        partyPrice: '£' + fullPrice,
        partyDate: this.formatDate(new Date(partyBooking.partyDate))
      }

      // await axios.post(
      //   config.serverURL + '/sendPartyOrderConfirmation',
      //   emailDetails
      // )
      // await axios.post(
      //   config.serverURL + '/sendPartyOrderAdminConfirmation',
      //   emailToAdmin
      // )

      let token = JSON.parse(window.localStorage.getItem('userData')).token

      const response = await axios.post(
        config.serverURL +
          '/PartyBooking' +
          config.endpoint +
          '?access_token=' +
          token,
        partyBooking
      )

      if (response.data.id) {
        var alert = {
          showAlert: true,
          type: 'success',
          message: 'Party booked successfully and log added',
          callback: () => {
            this.setState({ alert: _.clone(emptyAlert) })
            this.animateClose()
          }
        }
        this.setState({ alert })

        // let userId = JSON.parse(window.localStorage.getItem('userData')).userId

        // //Fetch changeLog
        // const changeLogResponse = await axios.get(
        //   config.serverURL + '/ChangeLogs',
        //   {
        //     params: {
        //       filter: {
        //         where: { changedBy: userId },
        //         order: 'changedAt DESC',
        //         limit: 1
        //       }
        //     }
        //   }
        // )
        // console.log('changeLogResponse', changeLogResponse.data)

        return
      }
    } catch (error) {
      errorMessage = error.message
      console.log('playonly - submit:', error.message)
    }
    var alert2 = {
      showAlert: true,
      message: errorMessage,
      type: 'error',
      callback: () => {
        this.setState({ alert: _.clone(emptyAlert) })
      }
    }
    this.setState({ alert: alert2 })
  }

  change = () => {
    var message = ''

    if (this.state.selectedType === null) message = pleaseSelectTText
    else if (this.state.childrenNum === 0 || this.state.childrenNum === '')
      message = pleaseSelectNText

    if (message !== '') {
      this.showAlert(message, 'warning')
      return
    }

    var type = types[this.state.selectedType]
    var dayOfWeek = new Date(this.state.partyDate).getDay()

    if (isNaN(dayOfWeek)) return 'Date error'

    var partyTime
    if (this.state.selectedTime === 'Custom') {
      partyTime = this.getCustomTime()
    } else {
      partyTime = this.state.selectedTime
        ? this.state.selectedTime
        : this.getSlots(this.state.partyDate)[0]
    }

    var additionalDetails = _.clone(this.state.additionalDetails)

    additionalDetails.partyChildDOB.month = this.getFullMonth(
      additionalDetails.partyChildDOB.month
    )

    var price =
      dayOfWeek === 0 || dayOfWeek === 6 ? type.peakPrice : type.offPrice

    this.props.bookingDates.forEach(dateObj => {
      if (
        this.isBetween(dateObj.startDate, dateObj.endDate, this.state.partyDate)
      ) {
        var dayOfWeek = moment(this.state.partyDate).day()
        var date = _.clone(dateObj['' + dayOfWeek])
        price = date.peak ? type.peakPrice : type.offPrice
      }
    })

    additionalDetails.menuOptions = additionalDetails.menuOptions
      ? additionalDetails.menuOptions
      : this.state.selectedType === 0 ||
        this.state.selectedType === 3 ||
        this.state.selectedType === 4 ||
        this.state.selectedType === 7
      ? 'Ham Rolls'
      : 'Hot Dogs'

    var data = {
      type: 'PartyBookings',
      id: this.props.partyObj.id,
      properties: {
        finalDue: this.state.finalDue,
        finalDueMethod: this.state.finalDueMethod,
        finalDueWhen: this.state.finalDueWhen,
        finalDueCashier: this.state.finalDueCashier,
        timeToChange: false,
        partyType: type.name,
        note: this.state.note,
        oldNote: this.props.partyObj.note,
        oldDate: this.props.partyObj.partyDate + this.props.partyObj.partyTime,
        partyDate: this.state.partyDate,
        partyTime: partyTime,
        oldAttendeeDetails: this.props.partyObj.attendeeDetails,
        attendeeDetails: {
          extraGuests: this.state.extraGuests,
          deposit: this.state.depositAmount * 100,
          totalDeposit: Number(this.state.totalDeposit) * 100,
          singleTicketPrice: price,
          youngSiblings: this.state.youngSiblings,
          quantity: Number(this.state.childrenNum),
          totalPrice: isNaN(this.getTotalPrice()) ? 0 : this.getTotalPrice()
        },
        additionalDetails: additionalDetails,
        themeItems: this.state.themeAmounts.map((amount, i) => {
          return {
            name: this.state.themeItems[i].name,
            quantity: amount === '' ? 0 : amount,
            price: this.state.themeItems[i].price
          }
        }),
        extraItems: this.state.itemsAmounts.map((amount, i) => {
          return {
            name: this.state.extraItems[i].name,
            quantity: amount === '' ? 0 : amount,
            price: this.state.extraItems[i].price
          }
        })
      }
    }
    this.props.sendRequest(updateBooking, data)
  }

  updateTimeToChange = () => {
    var data = {
      type: 'PartyBookings',
      id: this.props.partyObj.id,
      properties: {
        timeToChange: true
      }
    }

    this.props.sendRequest(updateBooking, data)
  }

  generateReferenceNumber = prefix => {
    var today = new Date()
    const year = today.getFullYear()
    var month = today.getMonth() + 1
    if (month < 10) month = '0' + month
    var day = today.getDate()
    if (day < 10) day = '0' + day
    const randomNo = Math.floor(Math.random() * 900000 + 100000)

    return prefix + year + month + day + randomNo
  }

  showAlert = (message, type) => {
    var alert = {
      showAlert: true,
      message: message,
      type: type,
      callback: () => {
        this.setState({ alert: _.clone(emptyAlert) })
      }
    }
    this.setState({ alert })
  }

  getFullMonth = month => {
    const months = {
      Jan: 'January',
      Feb: 'February',
      Mar: 'March',
      Apr: 'April',
      May: 'May',
      Jun: 'June',
      Jul: 'July',
      Aug: 'August',
      Sep: 'September',
      Oct: 'October',
      Nov: 'November',
      Dec: 'December'
    }

    return months[month]
  }

  getPrivateSubtotal = () => {
    var type = types[this.state.selectedType]
    if (!type || type.noPrice) return 'N/A'

    if (isNaN(this.state.childrenNum) || this.state.childrenNum === '')
      return 'N/A'

    var dayOfWeek = new Date(this.state.partyDate).getDay()
    if (isNaN(dayOfWeek)) return 'Date error'

    const extraGuests = this.state.extraGuests * type.extraPrice
    var price =
      dayOfWeek === 0 || dayOfWeek === 6 ? type.peakPrice : type.offPrice

    this.props.bookingDates.forEach(dateObj => {
      if (
        this.isBetween(dateObj.startDate, dateObj.endDate, this.state.partyDate)
      ) {
        var dayOfWeek = moment(this.state.partyDate).day()
        var date = _.clone(dateObj['' + dayOfWeek])
        price = date.peak ? type.peakPackagePrice : type.offPackagePrice
      }
    })

    return price + extraGuests
  }

  getSubtotalPrice = () => {
    var type = types[this.state.selectedType]

    if (!type || type.noPrice) return 'N/A'

    if (isNaN(this.state.childrenNum) || this.state.childrenNum === '')
      return 'N/A'

    var dayOfWeek = new Date(this.state.partyDate).getDay()
    if (isNaN(dayOfWeek)) return 'Date error'

    const rate = type.siblingPrice ? type.siblingPrice : 750
    const siblingsPrice = this.state.youngSiblings * rate
    var price =
      dayOfWeek === 0 || dayOfWeek === 6 ? type.peakPrice : type.offPrice

    this.props.bookingDates.forEach(dateObj => {
      if (
        this.isBetween(dateObj.startDate, dateObj.endDate, this.state.partyDate)
      ) {
        var dayOfWeek = moment(this.state.partyDate).day()
        var date = _.clone(dateObj['' + dayOfWeek])
        price = date.peak ? type.peakPrice : type.offPrice
      }
    })
    return this.state.childrenNum * price + siblingsPrice
  }

  getTotalPrice = () => {
    var subTotal = this.state.privateSelected
      ? this.getPrivateSubtotal()
      : this.getSubtotalPrice()

    if (isNaN(subTotal)) return subTotal

    this.state.themeAmounts.forEach((amount, i) => {
      if (amount !== '' && amount > 0)
        subTotal += amount * this.state.themeItems[i].price
    })

    this.state.itemsAmounts.forEach((amount, i) => {
      if (amount !== '' && amount > 0)
        subTotal += amount * this.state.extraItems[i].price
    })

    this.state.mascotsAmounts.forEach((amount, i) => {
      if (amount !== '' && amount > 0)
        subTotal += amount * this.state.mascotItems[i].price
    })

    const customDiscount =
      isNaN(this.state.customDiscount) || this.state.customDiscount === ''
        ? 0
        : Number(this.state.customDiscount) * 100
    const discount =
      this.state.discount.discountInstance &&
      this.state.discount.discountInstance.percentage
        ? this.state.discount.discountInstance.percentage / 100
        : 0
    const result = subTotal - customDiscount

    return result
  }

  getDiscountPrice = () => {
    var total = this.getTotalPrice()
    if (isNaN(total)) return total

    if (this.state.discount.discountApplied) {
      return this.state.discount.discountedAmount
        ? this.state.discount.discountedAmount
        : parseFloat(
            (
              (total *
                (1 - this.state.discount.discountInstance.percentage / 100)) /
              100
            ).toFixed(2)
          ) * 100
    } else {
      return 'N/A'
    }
  }

  getPayAmount = () => {
    var total = this.state.discount.discountApplied
      ? this.getDiscountPrice()
      : this.getTotalPrice()

    if (isNaN(total)) return 0

    return this.state.isDeposit ? this.state.totalDeposit * 100 : total
  }

  getSlots = date => {
    var temp = []
    this.props.bookingDates.forEach(dateObj => {
      if (this.isBetween(dateObj.startDate, dateObj.endDate, date)) {
        var dayOfWeek = moment(date).day()
        temp = _.clone(dateObj['' + dayOfWeek].timeSlots)
      }
    })
    temp.push('Custom')

    return temp
  }

  isBetween = (rangeStart, rangeEnd, date) => {
    var momentDate = moment(date).startOf('day')
    var momentStart = moment(rangeStart).startOf('day')

    if (rangeEnd === 'endless') {
      return (
        momentStart.isBefore(momentDate) ||
        momentStart.isSame(momentDate, 'day')
      )
    }
    var momentEnd = moment(rangeEnd).startOf('day')

    return (
      (momentStart.isBefore(momentDate) && momentDate.isBefore(momentEnd)) ||
      momentStart.isSame(momentDate, 'day') ||
      momentEnd.isSame(momentDate, 'day')
    )
  }

  getTypes = () => {
    const s = this.state.selectedType

    return types.map((type, i) => {
      return (
        <div className={'typeWrapper'} key={i}>
          <div className="typeRow">
            <IosArrowDown
              onClick={() => this.toogleOpenedType(i)}
              className="dropdownIcon"
              fontSize="5px"
              color="#fff"
            />
            <div onClick={() => this.toogleOpenedType(i)} className="typeName">
              {type.name}
            </div>
            <div
              className={
                'typeSelect' + (s !== null && s !== i ? ' noBorder' : '')
              }
              onClick={() => this.selectType(i)}>
              {s === i ? deselectText : s === null ? selectText : changeText}
            </div>
          </div>
          {this.state.openedTypes[i] && (
            <div className="typeDesc">
              {type.subtitle && (
                <div className="dropdownSubtitle">{type.subtitle}</div>
              )}
              <div className="dropdownPackages">
                <div className="packagesTitle">{packagesText + ':'}</div>
                {this.getPackagePoints(type.packages)}
              </div>
              <div className="dropdownSubtitle">{type.extra.description}</div>
              {type.extra.points && (
                <div className="packagePoints">
                  {this.getPackagePoints(type.extra.points)}
                </div>
              )}
              {!type.offPackagePrice ? (
                <div className="dropdownPackages">
                  <div className="packagesTitle">
                    {offPriceText + ': £' + type.offPrice / 100}
                  </div>
                </div>
              ) : (
                <div className="dropdownPackages">
                  <div className="packagesTitle">
                    {offPriceText + ': £' + type.offPackagePrice / 100}
                  </div>
                </div>
              )}
              {!type.peakPackagePrice ? (
                <div className="dropdownPackages">
                  <div className="packagesTitle">
                    {peakPriceText + ': £' + type.peakPrice / 100}
                  </div>
                </div>
              ) : (
                <div className="dropdownPackages">
                  <div className="packagesTitle">
                    {peakPriceText + ': £' + type.peakPackagePrice / 100}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )
    })
  }

  getPackagePoints = points => {
    return points.map((point, i) => {
      return (
        <div className="packageText" key={i}>
          <div className="packageBullet">{'-'}</div>
          <div>{point}</div>
        </div>
      )
    })
  }

  handleNumChange = (property, e) => {
    var value = e.target.value
    // var type = types[this.state.selectedType];
    // if (value !== '') {
    //   const limit = type.numberOfChildren ? 40 - type.numberOfChildren : 20;
    //   value = Number(value) > limit ? '' + limit : value
    // }
    this.setState({
      [property]: value
    })
  }

  handleInfoChange = (property, e, isDate) => {
    var value = e.target.value

    if (
      property === 'requireWheelchairAccess' ||
      property === 'payForExtraAdults' ||
      property === 'payForExtraChildren'
    )
      value = value === 'Yes' ? true : false

    if (isDate) {
      this.setState({
        additionalDetails: {
          ...this.state.additionalDetails,
          partyChildDOB: {
            ...this.state.additionalDetails.partyChildDOB,
            [property]: value
          }
        }
      })
    } else {
      this.setState({
        additionalDetails: {
          ...this.state.additionalDetails,
          [property]: value
        }
      })
    }
  }

  handleQuantityChange = (property, i, e) => {
    var propertyObj = this.state[property]
    propertyObj[i] = e.target.value

    this.setState({
      [property]: propertyObj
    })
  }

  getDaysList = () => {
    const year = this.state.additionalDetails.partyChildDOB.year
    const month = this.state.additionalDetails.partyChildDOB.month
    const amountOfDays = new Date(year, months.indexOf(month) + 1, 0).getDate()

    return days.slice(0, amountOfDays)
  }

  getMenuItems = () => {
    if (this.state.selectedType === null) return []
    else if (
      this.state.selectedType === 0 ||
      this.state.selectedType === 3 ||
      this.state.selectedType === 4 ||
      this.state.selectedType === 7
    )
      return menuItems1
    else return menuItems2
  }

  handleItemChange = (property, e) => {
    this.setState({
      newItem: {
        ...this.state.newItem,
        [property]: e.target.value
      }
    })
  }

  submitItem = () => {
    var item = _.clone(this.state.newItem)
    item.price = item.price * 100
    this.state.extraItems.push(item)
    this.initOpened(types, this.state.themeItems, this.state.extraItems)
    this.setState({
      newItem: {
        name: '',
        price: 0,
        description: []
      },
      openAddItem: false
    })
  }

  checkForAlert = () => {
    if (this.state.alert.showAlert) {
      return <Alert alert={this.state.alert} />
    } else if (this.props.requestFailed || this.props.requestFailed2) {
      var alert = _.clone(emptyAlert)
      alert.type = 'error'
      alert.showAlert = true
      alert.message = tryAgainText
      alert.callback = () => {
        if (this.props.requestFailed2) this.props.changeFinished2()
        else this.props.changeFinished()
      }

      return <Alert alert={alert} />
    } else if (this.props.requestFinished || this.props.requestFinished2) {
      var alert2 = _.clone(emptyAlert)
      alert2.type = 'success'
      alert2.showAlert = true
      alert2.callback = () => {
        if (this.props.requestFinished2) {
          this.props.changeFinished2()
          this.animateCloseOpen('checkbook')
        } else {
          this.props.closeWindow()
          this.props.changeFinished()
        }
      }

      return <Alert alert={alert2} />
    } else {
      return void 0
    }
  }

  updateUser = (id, data) => {
    this.props.updateUser({ id: id, properties: data })
  }

  flatten = price => {
    return isNaN(price) ? price : Math.round(price) / 100
  }

  openDelete = () => {
    this.setState({
      openDelete: true
    })
  }

  delete = () => {
    this.setState({
      openDelete: false
    })
    this.props.sendRequest(deleteBooking, {
      type: 'PartyBookings',
      id: this.props.partyObj.id
    })
  }

  cancelDelete = () => {
    this.setState({
      openDelete: false
    })
  }

  render() {
    var price =
      this.state.discount.discountInstance &&
      this.state.discount.discountInstance.percentage
        ? this.getTotalPrice() *
          (1 - this.state.discount.discountInstance.percentage / 100)
        : this.getTotalPrice()
    var isDiscountApplied = this.state.discount.discountApplied
    return (
      <div
        className={
          'partyWindow' + (this.state.shouldClose ? ' closeWindow' : '')
        }>
        <div className="partyForm">
          <IosCloseCircleOutline
            onClick={() => this.animateClose()}
            className="closeIcon"
            fontSize="30px"
            color="#fff"
          />
          {this.props.partyEditOn ? (
            <IosArrowRoundBack
              onClick={() => this.animateCloseOpen('checkbook')}
              className="backIcon"
              fontSize="45px"
              color="#fff"
            />
          ) : (
            void 0
          )}
          <div className="titleText">
            {this.props.partyEditOn ? bookParty2Text : bookPartyText}
          </div>
          {!this.props.partyEditOn && (
            <div>
              {!this.state.selectedUser.selected ? (
                <div className="searchWindow">
                  <div className="subtitleText">{pleaseSelectUText}</div>
                  <div className="inputWrapper">
                    <input
                      type="text"
                      value={this.state.search}
                      disabled={this.props.requestLoading}
                      onChange={e => this.setState({ search: e.target.value })}
                      placeholder={searchText}
                    />
                  </div>

                  <div className="inputWrapper">
                    <button
                      className="buttonWrapper"
                      type="submit"
                      onClick={this.getSearchItems}>
                      Search
                    </button>
                  </div>
                  <div className="searchWrapper searchBorder">
                    {this.state.items.length > 0
                      ? this.state.items.map((item, index) => {
                          return (
                            <div
                              className={
                                'searchRow smallText' +
                                (index + 1 === this.state.items.length
                                  ? ' noBorder'
                                  : '')
                              }
                              key={index}
                              onClick={() => this.selectUser(item)}>
                              <div>
                                {item.firstName + ' ' + item.lastName} -{' '}
                                {item.adminId ? 'Site' : 'Online'}
                              </div>
                              <div>{item.email}</div>
                            </div>
                          )
                        })
                      : ''}
                  </div>
                  <div className="searchWrapper addUserWrapper">
                    <div
                      className="searchRow addUserRow"
                      onClick={() => this.animateCloseOpen('register')}>
                      {addUserText}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="searchWrapper selectedWrapper flexRow">
                  <div className="searchRow smallText selectedRow">
                    <div>{this.state.selectedUser.user.email + ''}</div>
                  </div>
                  {!this.state.paymentDone && (
                    <div
                      className="searchChange"
                      onClick={() => this.unselectUser()}>
                      {changeText}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {this.props.partyEditOn && (
            <div>
              <div className="subtitleText">{userText}</div>
              <div className="userDetail">
                <div className="amountInputRow noBottomMargin">
                  <div className="itemText">
                    {this.props.partyObj.user.firstName}
                  </div>
                </div>
                <div className="amountInputRow noBottomMargin">
                  <div className="itemText">
                    {this.props.partyObj.user.lastName}
                  </div>
                </div>
              </div>
              <div className="userDetail">
                <div className="amountInputRow noBottomMargin">
                  <div className="itemText">
                    {this.props.partyObj.user.email}
                  </div>
                </div>
                <div className="amountInputRow noBottomMargin">
                  <div className="itemText">
                    {this.props.partyObj.user.phoneNumber}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="subtitleText">{selectTypeText}</div>
          <div className="typeDetail">{this.getTypes()}</div>
          <div className="priceDetail">
            <div className="subtitleText">{partyTimeText}</div>
          </div>
          <div>
            <DatePicker
              disabled={this.state.paymentDone}
              className="dateInput"
              onChange={this.handleDateChange}
              value={this.state.partyDate}
              clearIcon={null}
              calendarIcon={null}
            />
            <select
              className="partyTimeSelect"
              disabled={this.state.paymentDone}
              onChange={this.timeChange}
              value={this.state.selectedTime}>
              {this.getSlots(this.state.partyDate).map((item, index) => {
                return <option key={index}>{item}</option>
              })}
            </select>
            {this.state.selectedTime === 'Custom' && (
              <div className="partyCustomWrapper">
                <select
                  className="partyTimeSelect partyTimeCustom"
                  disabled={this.state.paymentDone}
                  onChange={e => this.setState({ customHours: e.target.value })}
                  value={this.state.customHours}>
                  {hours.map((item, index) => {
                    return <option key={index}>{item}</option>
                  })}
                </select>
                <select
                  className="partyTimeSelect partyTimeCustom"
                  disabled={this.state.paymentDone}
                  onChange={e =>
                    this.setState({ customMinutes: e.target.value })
                  }
                  value={this.state.customMinutes}>
                  {minutes.map((item, index) => {
                    return <option key={index}>{item}</option>
                  })}
                </select>
              </div>
            )}
          </div>
          <div className="subtitleText">{subtotalText}</div>
          {!this.state.privateSelected ? (
            <div className="amountInputRow">
              <div>{childrenNumText}</div>
              <div className="inputWrapper itemInput">
                <input
                  type="number"
                  value={this.state.childrenNum}
                  disabled={
                    this.props.paymentDone || this.state.selectedType == null
                  }
                  onChange={e => this.handleNumChange('childrenNum', e)}
                />
              </div>
            </div>
          ) : (
            <div className="amountInputRow">
              <div>{childrenNumText}</div>
              <div>{types[this.state.selectedType].numberOfChildren}</div>
            </div>
          )}
          <div className="amountInputRow">
            <div>
              {!this.state.privateSelected ? siblingNumText : extraGuests}
            </div>
            <div className="inputWrapper itemInput">
              <input
                type="number"
                value={
                  !this.state.privateSelected
                    ? this.state.youngSiblings
                    : this.state.extraGuests
                }
                disabled={
                  this.props.paymentDone || this.state.selectedType == null
                }
                onChange={e =>
                  this.handleNumChange(
                    !this.state.privateSelected
                      ? 'youngSiblings'
                      : 'extraGuests',
                    e
                  )
                }
              />
            </div>
          </div>

          <div className="amountInputRow">
            <div>{amountText}</div>
            <div>
              {'£ ' +
                (!this.state.privateSelected
                  ? this.getSubtotalPrice() / 100
                  : this.getPrivateSubtotal() / 100)}
            </div>
          </div>

          <div className="subtitleText">{partyDetailsText}</div>
          <div className="partyDetails">
            <div className="partyInputHeader">{partyReasonText}</div>
            <select
              className="partyDetailsSelect"
              onChange={e => this.handleInfoChange('partyReason', e)}
              value={this.state.additionalDetails.partyReason}>
              {reasons.map((item, index) => {
                return <option key={index}>{item}</option>
              })}
            </select>
            <div className="partyInputHeader">{partyForText}</div>
            <div className="inputWrapper partyInput">
              <input
                type="text"
                value={this.state.additionalDetails.whoIsPartyFor}
                onChange={e => this.handleInfoChange('whoIsPartyFor', e)}
              />
            </div>
            <div className="partyInputHeader">{genderText}</div>
            <select
              className="partyDetailsSelect"
              onChange={e => this.handleInfoChange('partyChildGender', e)}
              value={this.state.additionalDetails.partyChildGender}>
              {[
                'Female(s)',
                'Male(s)',
                'Female(s) and Male(s)',
                'Female',
                'Male',
                'Not Selected'
              ].map((item, index) => {
                return <option key={index}>{item}</option>
              })}
            </select>
            <div className="partyInputHeader">{howOldText}</div>
            <div className="inputWrapper partyInput">
              <input
                type="number"
                onChange={e => this.handleInfoChange('howOldWillTheyBe', e)}
                value={this.state.additionalDetails.howOldWillTheyBe}
              />
            </div>
            <div className="partyInputHeader">{dateOfBirth}</div>
            <div className="partyDayWrapper">
              <select
                className="partyDaySelect"
                onChange={e => this.handleInfoChange('day', e, true)}
                value={this.state.additionalDetails.partyChildDOB.day}>
                {this.getDaysList().map((item, index) => {
                  return <option key={index}>{item}</option>
                })}
              </select>
              <select
                className="partyDaySelect"
                onChange={e => this.handleInfoChange('month', e, true)}
                value={this.state.additionalDetails.partyChildDOB.month}>
                {months.map((item, index) => {
                  return <option key={index}>{item}</option>
                })}
              </select>
              <select
                className="partyDaySelect"
                onChange={e => this.handleInfoChange('year', e, true)}
                value={this.state.additionalDetails.partyChildDOB.year}>
                {years.map((item, index) => {
                  return <option key={index}>{item}</option>
                })}
              </select>
            </div>
            <div className="partyInputHeader">{menuText}</div>
            <select
              className="partyDetailsSelect"
              onChange={e => this.handleInfoChange('menuOptions', e)}
              value={this.state.additionalDetails.menuOptions}>
              {this.getMenuItems().map((item, index) => {
                return <option key={index}>{item}</option>
              })}
            </select>
            <div className="partyInputHeader">{wheelchairText}</div>
            <select
              className="partyDetailsSelect"
              onChange={e =>
                this.handleInfoChange('requireWheelchairAccess', e)
              }
              value={
                this.state.additionalDetails.requireWheelchairAccess
                  ? 'Yes'
                  : 'No'
              }>
              {['No', 'Yes'].map((item, index) => {
                return <option key={index}>{item}</option>
              })}
            </select>
            <div className="partyInputHeader">{extraAdultsText}</div>
            <select
              className="partyDetailsSelect"
              onChange={e => this.handleInfoChange('payForExtraAdults', e)}
              value={
                this.state.additionalDetails.payForExtraAdults ? 'Yes' : 'No'
              }>
              {['Yes', 'No'].map((item, index) => {
                return <option key={index}>{item}</option>
              })}
            </select>
            <div className="partyInputHeader partyInputHeaderE">
              {extraChildrenText}
            </div>
            <select
              className="partyDetailsSelect"
              onChange={e => this.handleInfoChange('payForExtraChildren', e)}
              value={
                this.state.additionalDetails.payForExtraChildren ? 'Yes' : 'No'
              }>
              {['No', 'Yes'].map((item, index) => {
                return <option key={index}>{item}</option>
              })}
            </select>
          </div>
          <div className="bookingButtons">
            <div className="buttonWrapper" onClick={this.toggleItems}>
              {this.state.showAll ? showItem : hideItem}
            </div>
          </div>
          <div className="subtitleText">{themeTitleText}</div>
          <div className="extraItems">
            {this.state.themeItems.map((item, i) => {
              return (
                <div className={'typeWrapper'} key={i}>
                  {this.state.themeAmounts[i] > 0 || this.state.showAll ? (
                    <div className="typeRow">
                      <IosArrowDown
                        onClick={() => this.toogleOpenedTheme(i)}
                        className="dropdownIcon"
                        fontSize="5px"
                        color="#fff"
                      />
                      <div
                        onClick={() => this.toogleOpenedTheme(i)}
                        className="itemName">
                        {item.name}
                      </div>
                      <div className="inputWrapper itemInput">
                        <input
                          type="number"
                          value={
                            isNaN(this.state.themeAmounts[i])
                              ? ''
                              : this.state.themeAmounts[i]
                          }
                          disabled={this.props.paymentDone}
                          onChange={e =>
                            this.handleQuantityChange('themeAmounts', i, e)
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {this.state.openedThemes[i] && (
                    <div className="typeDesc">
                      {item.description.map((desc, j) => {
                        return (
                          <div className="itemDesc" key={j}>
                            {desc}
                          </div>
                        )
                      })}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
          <div className="subtitleText">{extraItemsText}</div>
          <div className="extraItems">
            {this.state.extraItems.map((item, i) => {
              return (
                <div className={'typeWrapper'} key={i}>
                  {this.state.itemsAmounts[i] > 0 || this.state.showAll ? (
                    <div className="typeRow">
                      <IosArrowDown
                        onClick={() => this.toogleOpenedItem(i)}
                        className="dropdownIcon"
                        fontSize="5px"
                        color="#fff"
                      />
                      <div
                        onClick={() => this.toogleOpenedItem(i)}
                        className="itemName">
                        {item.name}
                      </div>
                      <div className="inputWrapper itemInput">
                        <input
                          type="number"
                          value={
                            isNaN(this.state.itemsAmounts[i])
                              ? ''
                              : this.state.itemsAmounts[i]
                          }
                          disabled={this.props.paymentDone}
                          onChange={e =>
                            this.handleQuantityChange('itemsAmounts', i, e)
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {this.state.openedItems[i] && (
                    <div className="typeDesc">
                      {item.description.map((desc, j) => {
                        return (
                          <div className="itemDesc" key={j}>
                            {desc}
                          </div>
                        )
                      })}
                      <div className="itemDesc">
                        {priceText + ': £' + item.price / 100}
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
          <div className="subtitleText">{mascotItemsText}</div>
          <div className="extraItems">
            {this.state.mascotItems.map((item, i) => {
              return (
                <div className={'typeWrapper'} key={i}>
                  {this.state.mascotsAmounts[i] > 0 || this.state.showAll ? (
                    <div className="typeRow">
                      <IosArrowDown
                        onClick={() => this.toogleOpenedItem(i)}
                        className="dropdownIcon"
                        fontSize="5px"
                        color="#fff"
                      />
                      <div
                        onClick={() => this.toogleOpenedItem(i)}
                        className="itemName">
                        {item.name}
                      </div>
                      <div className="inputWrapper itemInput">
                        <input
                          type="number"
                          value={
                            isNaN(this.state.mascotsAmounts[i])
                              ? ''
                              : this.state.mascotsAmounts[i]
                          }
                          disabled={this.props.paymentDone}
                          onChange={e =>
                            this.handleQuantityChange('mascotsAmounts', i, e)
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {this.state.openedItems[i] && (
                    <div className="typeDesc">
                      {item.description.map((desc, j) => {
                        return (
                          <div className="itemDesc" key={j}>
                            {desc}
                          </div>
                        )
                      })}
                      <div className="itemDesc">
                        {priceText + ': £' + item.price / 100}
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
          {this.state.openAddItem ? (
            <div className="addInputWrapper">
              <div className="itemTitle">{addItemText}</div>
              <div className="itemInputHeader">{customNameText}</div>
              <div className="inputWrapper itemInput">
                <input
                  type="text"
                  value={this.state.newItem.name}
                  disabled={this.props.paymentDone}
                  onChange={e => this.handleItemChange('name', e)}
                />
              </div>
              <div className="itemInputHeader">{customPriceText}</div>
              <div className="inputWrapper itemInput">
                <input
                  type="number"
                  value={this.state.newItem.price}
                  disabled={this.props.paymentDone}
                  onChange={e => this.handleItemChange('price', e)}
                />
              </div>
              <div className="itemButtons">
                <div
                  className="itemButton noBorder"
                  onClick={() => this.setState({ openAddItem: false })}>
                  {cancelText}
                </div>
                <div className="itemButton" onClick={this.submitItem}>
                  {submitText}
                </div>
              </div>
            </div>
          ) : (
            <div className="searchWrapper addUserWrapper">
              <div
                className="searchRow addUserRow"
                onClick={() => this.setState({ openAddItem: true })}>
                {addItemText}
              </div>
            </div>
          )}
          <div className="subtitleText">{totalText}</div>
          <div className="amountInputRow">
            Order date:{' '}
            {this.props.partyObj.orderDate
              ? this.props.partyObj.orderDate.slice(0, 10)
              : ''}{' '}
            Transaction ref: {this.props.partyObj.id}
          </div>
          <div>
            {!this.props.partyEditOn && (
              <div className="amountInputRow">
                <div>{amountText}</div>
                <div>{'£ ' + this.flatten(price)}</div>
              </div>
            )}

            {this.props.partyEditOn && (
              <span>
                <div className="amountInputRow">
                  <div>
                    {isDiscountApplied ? discountedTotalText : amountText}
                  </div>
                  <div>
                    {'£ ' +
                      (isDiscountApplied
                        ? this.flatten(this.state.discount.discountedAmount)
                        : this.flatten(price))}
                  </div>
                </div>
              </span>
            )}
            {this.props.partyEditOn &&
            (this.state.customDiscount ||
              this.state.discount.discountedAmount) ? (
              <div className="amountInputRow">
                <div>{initialText}</div>
                <div>
                  {'£ ' + this.state.customDiscount
                    ? parseFloat(this.state.totalPrice) +
                      parseFloat(this.state.customDiscount)
                    : this.state.totalPrice}
                </div>
              </div>
            ) : (
              <span></span>
            )}
            {this.props.partyEditOn && isDiscountApplied && (
              <div className="amountInputRow">
                <div>{discountCodeText}</div>
                <div>{this.state.discount.discountInput}</div>
              </div>
            )}
            {this.props.partyEditOn && !isNaN(price) && (
              <div style={{ width: 'inherit' }}>
                <div className="amountInputRow">
                  <div>{paidAmountText}</div>
                  <div>
                    {'£ ' + this.state.amountPaid}
                  </div>
                </div>
              </div>
            )}
            {!this.props.partyEditOn && (
              <div className="amountInputRow">
                <div>{discountedTotalText}</div>
                <div>
                  {'£ ' +
                    (isNaN(this.getDiscountPrice())
                      ? this.getDiscountPrice()
                      : this.getDiscountPrice() / 100)}
                </div>
              </div>
            )}

            {!this.props.partyEditOn && (
              <div className="priceWrapper">
                <div className="inputWrapper discountInput">
                  <input
                    type="text"
                    value={this.state.discount.discountInput}
                    onChange={e => {
                      this.setState({
                        discount: {
                          ...this.state.discount,
                          discountInput: e.target.value
                        }
                      })
                    }}
                    placeholder={discountCodeText}
                  />
                  <div className="applyButton" onClick={this.applyDiscount}>
                    {applyText}
                  </div>
                </div>
              </div>
            )}
            {!this.props.partyEditOn && (
              <div className="amountInputRow">
                <div>{discountCustomText}</div>
                <div className="inputWrapper itemInput">
                  <input
                    type="number"
                    value={this.state.customDiscount}
                    onChange={e =>
                      this.setState({ customDiscount: e.target.value })
                    }
                  />
                </div>
              </div>
            )}

            <div>
              <div className="amountInputRow">
                <div>
                  {!this.props.partyEditOn
                    ? depositAmountText
                    : depositAmountText2}
                </div>
                <div className="inputWrapper itemInput">
                  <input
                    type="number"
                    value={this.state.totalDeposit}
                    onChange={e =>
                      this.setState({ totalDeposit: e.target.value })
                    }
                  />
                </div>
              </div>
              {this.state.totalDeposit > 0 && (
                  <div>
                    <div className="amountInputRow">
                      <div>{depositText}</div>
                      <div>{'£ ' + this.state.totalDeposit}</div>
                    </div>

                    <div className="amountInputRow">
                      <div>{restToPayText}</div>
                      <div>
                        {'£ ' +
                          (
                            this.flatten(price) - this.state.totalDeposit
                          ).toFixed(2)}
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
          <div className="subtitleText">{noteText}</div>
          <textarea
            className="noteArea"
            value={this.state.note}
            onChange={e => {
              this.setState({ note: e.target.value })
            }}></textarea>
          <div className="bookingButtons">
            {!this.state.paymentDone && !this.props.partyEditOn && (
              <div
                className="buttonWrapper marginRight"
                onClick={() => this.openPayment(false)}>
                {payText}
              </div>
            )}
            {!this.state.paymentDone && !this.props.partyEditOn && (
              <div
                className="buttonWrapper marginRight"
                onClick={() => this.openPayment(true)}>
                {depositText}
              </div>
            )}
            {this.props.partyEditOn && (
              <div
                className="buttonWrapper marginRight redColour"
                onClick={() => this.openDelete()}>
                {deleteText}
              </div>
            )}
            {this.props.partyEditOn && (
              <div
                className="buttonWrapper marginRight"
                onClick={() => this.updateTimeToChange()}>
                {updateTimeText}
              </div>
            )}
            <div
              className="buttonWrapper"
              onClick={() =>
                this.props.partyEditOn ? this.change() : this.submit()
              }>
              {this.props.partyEditOn ? changeText : submitText}
            </div>
          </div>

          <div className="bookingButtons">
            <div className="amountInputRow">
              <div>{finalDue}</div>
              <div className="inputWrapper itemInput">
                <input
                  type="number"
                  value={this.state.finalDue}
                  onChange={e => this.setState({ finalDue: e.target.value })}
                />
              </div>
            </div>
            <div className="amountInputRow">
              <div>{finalDueWhen}</div>
              <div className="inputWrapper itemInput">
                <input
                  type="string"
                  value={this.state.finalDueWhen}
                  onChange={e =>
                    this.setState({ finalDueWhen: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
          <div className="bookingButtons">
            <div className="amountInputRow">
              <div>{finalDueMethod}</div>
              <div className="inputWrapper itemInput">
                <input
                  type="string"
                  value={this.state.finalDueMethod}
                  onChange={e =>
                    this.setState({ finalDueMethod: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="amountInputRow">
              <div>{finalDueCashier}</div>
              <div className="inputWrapper itemInput">
                <input
                  type="string"
                  value={this.state.finalDueCashier}
                  onChange={e =>
                    this.setState({ finalDueCashier: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="marginBottom"></div>
        {this.state.openDelete && (
          <div className="deleteWrapper">
            <div className="deletePopup">
              <div className="deleteWarning">{warningText}</div>
              <div className="deleteText">{warningMessageText}</div>
              <div className="deleteButtons">
                <div className="buttonWrapper redColour" onClick={this.delete}>
                  {confirmText}
                </div>
                <div className="buttonWrapper" onClick={this.cancelDelete}>
                  {cancelText}
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showPayment && (
          <Payment
            amount={this.getPayAmount()}
            updateUser={this.updateUser}
            user={this.state.selectedUser.user}
            successCallback={this.submit}
            closePayment={this.closePayment}
          />
        )}
        {this.checkForAlert()}
      </div>
    )
  }
}

const mapStateToProps = ({ admin, users, bookedit, bookings }) => ({
  users: users.users,
  bookingDates: bookings.bookingDates,
  recentUsers: users.recentUsers,
  requestFailed: users.requestFailed,
  requestFailed2: bookedit.requestFailed,
  requestLoading: users.requestLoading,
  userForBooking: users.userForBooking,
  requestFinished: users.requestFinished,
  requestFinished2: bookedit.requestFinished,
  partyObj: bookedit.partyObj,
  partyEditOn: bookedit.partyEditOn
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      redirectDone,
      sendRequest,
      changeFinished,
      newUserRequired,
      fetchNone,
      newUserNotRequired,
      updateUser,
      changeFinished2,
      editFinished
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Party)
